<template>
  <hb-basic-page
    :action-buttons="$vuetify.breakpoint.smAndDown ? {} : {}"
    :back-button="{ show: true, fallback: 'tenant_start' }"
    :fill-height="true"
    :loading="loading"
    :subtle-loading="subtleLoading"
    :title="$tc('financials.title', 2)"
    name="financials-view"
  >
    <v-col cols="12">
      <v-row align="center" class="fill-height" no-gutters>
        <no-content-view
          :description="$t('financials.coming_soon_description')"
          :reload-button="false"
          :title="$t('financials.coming_soon')"
          title-image="img/undraw_projections_re_ulc6.svg"
        />
      </v-row>
    </v-col>

    <template v-if="false">
      <v-col v-if="!loading && financials.length > 0" cols="12" lg="10" md="10" offset-lg="1" offset-md="1" offset-xl="2"
             xl="8">
        <v-row>
          <v-col cols="12">
            <!--
            <v-row>
              <v-col cols="12">
                <v-btn @click="fetchFinancial">Hae</v-btn>
              </v-col>
            </v-row>
            -->
            <v-row>
              <v-col cols="12" md="12">
                <v-card>
                  <v-card-title>
                    <section-header>
                      {{ $t('financials.financial_kpis') }}
                    </section-header>
                    <v-spacer></v-spacer>
                    <v-row
                      :style="{ width: $vuetify.breakpoint.xsOnly ? '100%' : '' }"
                      align="center"
                      class="fill-height font-weight-regular"
                      justify="end"
                      no-gutters
                    >
                      <v-select
                        v-model="selectedFinancialIndex"
                        :class="$vuetify.breakpoint.xsOnly ? 'mt-3' : ''"
                        :items="years"
                        :label="$t('financials.choose_year')"
                        :style="{ maxWidth: $vuetify.breakpoint.xsOnly ? '100%' : '200px' }"
                        dense
                        hide-details
                        item-text="year"
                        item-value="index"
                        outlined
                      />
                    </v-row>
                  </v-card-title>
                  <v-card-text class="text-body-2 text-sm-body-1">
                    {{ $t('financials.kpi_explained') }}
                  </v-card-text>
                  <v-card-text class="mt-3">
                    <v-row>
                      <template v-for="(f, index) in financialCards">
                        <financial-card
                          :key="index"
                          :financial="selectedFinancial"
                          :grade="f.grade"
                          :name="f.name"
                          :previousFinancial="previousFinancial"
                          :value-type="f.valueType"
                        />
                      </template>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>

      <v-col
        v-if="!loading && richFinancials.length === 0 && !tenant.dunsNumber"
        class="pa-0 fill-height"
        cols="12"
        lg="8"
        md="8"
        offset-lg="2"
        offset-md="2"
        offset-xl="3"
        xl="6"
      >
        <v-row align="center" class="fill-height" no-gutters>
          <no-duns-number :tenant="tenant" @duns-number-saved="fetchFinancial"/>
        </v-row>
      </v-col>

      <v-col
        v-if="!$isPaidTenant && !loading && tenant.dunsNumber"
        class="pa-0 fill-height"
        cols="12"
        lg="8"
        md="8"
        offset-lg="2"
        offset-md="2"
        offset-xl="3"
        xl="6"
      >
        <v-row align="center" class="fill-height" no-gutters>
          <no-content-view
            :description="$t('financials.pro_or_higher_plan_is_required_description')"
            :function-button="true"
            :function-button-text="$t('financials.go_to_tenant_settings')"
            :prop-function="goToTenantSettings"
            :reload-button="false"
            :title="$t('financials.pro_or_higher_plan_is_required')"
            function-button-icon="mdi mdi-arrow-right"
            title-icon="mdi mdi-chart-timeline-variant-shimmer"
          />
        </v-row>
      </v-col>

      <v-col
        v-if="$isPaidTenant && !loading && richFinancials.length === 0 && tenant.dunsNumber"
        class="pa-0 fill-height"
        cols="12"
        lg="8"
        md="8"
        offset-lg="2"
        offset-md="2"
        offset-xl="3"
        xl="6"
      >
        <v-row align="center" class="fill-height" no-gutters>
          <no-content-view
            :description="$t('financials.no_financial_data_to_display_text')"
            :function-button="true"
            :function-button-text="$t('financials.go_to_tenant_settings')"
            :prop-function="goToTenantSettings"
            :reload-button="false"
            :title="$t('financials.no_financial_data_to_display')"
            function-button-icon="mdi mdi-arrow-right"
            title-icon="mdi mdi-chart-timeline-variant-shimmer"
          />
        </v-row>
      </v-col>
    </template>

  </hb-basic-page>
</template>

<script>
import SectionHeader from '@/components/SectionHeader';
import financials from '@/api/financials';
import surveyApi from "@/api/survey";
import dayjs from 'dayjs';
import FinancialCard from '@/components/Tenant/Financials/FinancialCard';
import NoDunsNumber from '@/components/Tenant/Financials/NoDunsNumber';
import tenantApi from '@/api/tenant';
import NoContentView from '@/components/NoContentView';

export default {
  name: 'FinancialsView',
  components: {NoContentView, NoDunsNumber, FinancialCard, SectionHeader},
  data() {
    return {
      loading: true,
      subtleLoading: false,
      searchPhrase: '',
      /*
      titleButton: {
        text: this.$t('financials.create_financial'),
        icon: 'add',
        callback: this.handleCreateSurvey,
        primary: true,
      },
       */
      surveys: [],
      financials: [],
      tenant: {},
      selectedFinancialIndex: 0,
      fetchFinancialsDone: false,
    };
  },
  computed: {
    previousFinancial() {
      if (this.financials.length - 1 >= this.selectedFinancialIndex) {
        return this.financials[this.selectedFinancialIndex + 1];
      }
      return null;
    },
    financialCards() {
      return [
        {name: 'salesRevenue'},
        {name: 'salesMargin'},
        {name: 'salesMarginPercentage', valueType: 'percentage'},
        {name: 'debtsPercentage', valueType: 'percentage', inverted: true},
        {name: 'ebitda'},
        {name: 'ebitdapercentage', valueType: 'percentage'},
        {name: 'workingCapitalCalculated'},
        {name: 'workingCapitalPercentage', valueType: 'percentage'},
        /*{ name: 'valueAdded' },
        { name: 'valueAddedPerPerson' },
        { name: 'valueAddedPerPersonnelCosts' },*/
        {name: 'inventoriesToRevenuePercentage', valueType: 'percentage'},
        {name: 'salesReceivablesCycle', valueType: 'none'},
        /*{ name: 'tradePayablesCycle', valueType: 'none' },

        { name: 'hcroi', valueType: 'none', grade: [2.2,2.5,2.9]},*/
        {name: 'investedCapitalReturnPercentage', valueType: 'percentage', grade: [0, 0.089, 0.149, 0.25]},
        {name: 'quickRatio', valueType: 'none', grade: [0.5, 1]},
        {name: 'currentRatio', valueType: 'none', grade: [1, 2]},
        {name: 'equityRatioPercentage', valueType: 'percentage', grade: [0.2, 0.4]},
        {name: 'totalReturnOfEquityPercentage', valueType: 'percentage', grade: [0.05, 0.1]},
      ];
    },
    richFinancials() {
      return this.financials;
    },
    selectedFinancial() {
      return this.selectedFinancialIndex >= 0 ? this.financials[this.selectedFinancialIndex] : null;
    },
    years() {
      let analysisYears = [];
      let financialYears = this.financials
        .map(f => f.financialStatementToDate)
        .map((y, i) => {
          return {
            year: dayjs(y).year(),
            date: y,
            index: i,
          };
        });
      financialYears.sort((a, b) => b.year - a.year);

      if (this.surveys.length > 0) {
        analysisYears = [...new Set(this.surveys.flatMap(s => [s.start, s.end].map(d => dayjs(d).year())).filter(Boolean))];
      }
      analysisYears.sort((a, b) => b - a)
      if (analysisYears.length <= 1 || analysisYears[0] - analysisYears[analysisYears.length - 1] < 4) {
        return financialYears.slice(0, 4);
      } else {
        return financialYears.filter(f => (f.year >= analysisYears[analysisYears.length - 1]));
      }
    },
  },
  methods: {
    goToTenantSettings() {
      this.$router.push({name: 'tenant_settings'});
    },
    handleSearch(searchPhrase) {
      this.searchPhrase = searchPhrase;
    },
    async fetchFinancial() {
      this.loading = true;
      try {
        await financials.fetchDnbData();
      } catch (e) {
        this.$handleApiError(e);
      }
      this.fetchFinancialsDone = true;
      await this.reload();
      this.loading = false;
    },
    async reloadSurveys() {
      try {
        this.surveys = await surveyApi.getSurveys();
      } catch (e) {
        this.$handleApiError(e);
      }
    },
    async reloadFinancials() {
      try {
        this.financials = await financials.getFinancials();
        if (this.financials.length === 0) {
          this.tenant = await tenantApi.getCurrentTenant();
          if (this.tenant.dunsNumber && !this.fetchFinancialsDone) {
            await this.fetchFinancial();
          }
        }
      } catch (e) {
        this.$handleApiError(e);
      }
    },
    async reload() {
      if (this.financials.length > 0) {
        this.subtleLoading = true;
        this.loading = false;
      } else {
        this.loading = true;
        this.subtleLoading = false;
      }
      await this.reloadSurveys();
      await this.reloadFinancials();
      this.loading = false;
      this.subtleLoading = false;
    },
  },
  mounted() {
    this.loading = false;
    //this.reload();
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss"></style>
